import {BoltRuntimesObject} from './BoltRuntimes'
import {runtime as boltResponsiveRuntimes} from 'bolt-responsive'

export const BoltResponsiveRuntimes = Object.values({
    ...BoltRuntimesObject,
    ...boltResponsiveRuntimes
})
